import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import { CustomerProvider } from './context/CustomerContext';
import { MenuProvider } from './context/MenuContext';
import { ReviewsProvider } from './context/ReviewsContext';
import { SettingsProvider } from './context/SettingsContext';
import { UserProvider } from './context/UserContext';
import { FinanceProvider } from './context/FinanceContext';
import { OffersProvider } from './context/OffersContext';
import { OutletProvider } from '../context/OutletContext';
import { ReportingProvider } from './context/ReportingContext';
import { DeliveryProvider } from './context/DeliveryContext';
import { InventoryProvider } from './context/InventoryContext';
import { LocationProvider } from './context/LocationContext';
import { BillingProvider } from './context/BillingContext';
import { AccountingProvider } from './context/AccountingContext';
import { TableProvider } from '../waiter/context/TableContext';
import { TerminalProvider } from '../waiter/context/TerminalContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Outlets from './pages/Outlets';
import OutletMenus from './pages/OutletMenus';
import ThermalPrinter from './pages/ThermalPrinter';
import LoyaltyProgram from './pages/LoyaltyProgram';
import RedemptionHistory from './pages/RedemptionHistory';
import ScheduledOrders from './pages/ScheduledOrders';
import SalesForecasting from './pages/Analytics/SalesForecasting';
import CustomerSegmentation from './pages/Analytics/CustomerSegmentation';
import MenuEngineering from './pages/Analytics/MenuEngineering';
import StaffPerformance from './pages/Analytics/StaffPerformance';
import PredictiveInsights from './pages/Analytics/PredictiveInsights';
import POSSettings from './pages/POSSettings';
import AdminTableManagement from './pages/Tables/AdminTableManagement';
import AdminTerminalManagement from './pages/AdminTerminalManagement';
import './AdminApp.css';

const AdminContent = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!currentUser) {
    return <Login />;
  }

  return (
    <OrderProvider>
      <CustomerProvider>
        <MenuProvider>
          <ReviewsProvider>
            <SettingsProvider>
              <UserProvider>
                <FinanceProvider>
                  <OffersProvider>
                    <OutletProvider>
                      <ReportingProvider>
                        <DeliveryProvider>
                          <InventoryProvider>
                            <LocationProvider>
                              <BillingProvider>
                                <AccountingProvider>
                                  <TerminalProvider>
                                    <TableProvider>
                                      <Routes>
                                    <Route path="/" element={<Dashboard />} />
                                    <Route path="/outlets" element={<Outlets />} />
                                    <Route path="/outlet-menus" element={<OutletMenus />} />
                                    <Route path="/thermal-printer" element={<ThermalPrinter />} />
                                    <Route path="/loyalty" element={<LoyaltyProgram />} />
                                    <Route path="/redemption-history" element={<RedemptionHistory />} />
                                    <Route path="/scheduled-orders" element={<ScheduledOrders />} />
                                    <Route path="/analytics/sales-forecasting" element={<SalesForecasting />} />
                                    <Route path="/analytics/customer-segmentation" element={<CustomerSegmentation />} />
                                    <Route path="/analytics/menu-engineering" element={<MenuEngineering />} />
                                    <Route path="/analytics/staff-performance" element={<StaffPerformance />} />
                                    <Route path="/analytics/predictive-insights" element={<PredictiveInsights />} />
                                    <Route path="/pos-settings" element={<POSSettings />} />
                                    <Route path="/tables" element={<AdminTableManagement />} />
                                    <Route path="/terminals" element={<AdminTerminalManagement />} />
                                    <Route path="*" element={<Navigate to="/admin" replace />} />
                                      </Routes>
                                    </TableProvider>
                                  </TerminalProvider>
                                </AccountingProvider>
                              </BillingProvider>
                            </LocationProvider>
                          </InventoryProvider>
                        </DeliveryProvider>
                      </ReportingProvider>
                    </OutletProvider>
                  </OffersProvider>
                </FinanceProvider>
              </UserProvider>
            </SettingsProvider>
          </ReviewsProvider>
        </MenuProvider>
      </CustomerProvider>
    </OrderProvider>
  );
};

const AdminApp = () => {
  return (
    <AuthProvider>
      <AdminContent />
    </AuthProvider>
  );
};

export default AdminApp;
